// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import MaintainaceTable from './maintainace-table';
// assets
//

// ----------------------------------------------------------------------

export default function MaintainaceProduct() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <MaintainaceTable />
        </Container >
    );
}
